var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-dashboard" }, [
    _c(
      "div",
      { staticClass: "my-layout" },
      [
        _c(
          "md-card",
          { staticClass: "custom-card" },
          [
            _c(
              "md-card-header",
              {
                staticClass:
                  "md-card-header-icon md-card-header-warning card-container",
              },
              [
                _c(
                  "div",
                  { staticClass: "create-container pull-right" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-primary md-just-icon md-round pull-right custom-add",
                        attrs: {
                          disabled: _vm.loadingRequiredData,
                          title: "Create adjustment",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.createAdjustment($event)
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("library_add")])],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("md-card-content", { staticClass: "body-list" }, [
              _vm.selectedRows.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "bulk-section sticky-selection",
                      class: [{ fixed: _vm.isFixedSelector }],
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.selectedRows.length) +
                            " adjustment" +
                            _vm._s(_vm.selectedRows.length > 1 ? "s" : "") +
                            " selected.\n                    "
                        ),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-round md-just-icon md-success",
                              attrs: { title: "Approve" },
                              on: { click: _vm.bulkApprove },
                            },
                            [_c("md-icon", [_vm._v("thumb_up")])],
                            1
                          ),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-round md-just-icon md-danger",
                              attrs: { title: "Deny" },
                              on: { click: _vm.bulkDeny },
                            },
                            [_c("md-icon", [_vm._v("thumb_down")])],
                            1
                          ),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-round md-just-icon md-danger",
                              attrs: { title: "Delete" },
                              on: { click: _vm.bulkDelete },
                            },
                            [_c("md-icon", [_vm._v("delete")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                [
                  _c(
                    "md-table",
                    {
                      staticClass:
                        "context-menu-support custom-paginated-table",
                    },
                    [
                      _c(
                        "md-table-row",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("md-checkbox", {
                            staticClass: "checkbox-container checkbox-head",
                            on: {
                              change: function ($event) {
                                return _vm.onSelectAll(_vm.isSelectAll)
                              },
                            },
                            model: {
                              value: _vm.isSelectAll,
                              callback: function ($$v) {
                                _vm.isSelectAll = $$v
                              },
                              expression: "isSelectAll",
                            },
                          }),
                          _c("md-table-head", [_vm._v("Created Date")]),
                          _c("md-table-head", [
                            _vm._v(_vm._s(_vm.getColumnName())),
                          ]),
                          _c("md-table-head", [_vm._v("Adjustment Date")]),
                          _c("md-table-head", [_vm._v("Amount")]),
                          _c("md-table-head", [_vm._v("Category")]),
                          _c("md-table-head", [_vm._v("Description")]),
                          _c("md-table-head", [_vm._v("Requested By")]),
                          _c("md-table-head", [_vm._v("Approved By")]),
                          _c("md-table-head", [_vm._v("Approval Status")]),
                          _vm.isTeamOwner
                            ? _c("md-table-head", [_vm._v("Actions")])
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.isLoading &&
                      _vm.adjustmentList &&
                      _vm.adjustmentList.length > 0
                        ? _vm._l(_vm.adjustmentList, function (adj, index) {
                            return _c(
                              "md-table-row",
                              { key: index },
                              [
                                _c(
                                  "md-table-cell",
                                  [
                                    !adj.customerInvoiceId &&
                                    !adj.teamMemberInvoiceId &&
                                    _vm.hideIfDeleted(adj)
                                      ? _c("md-checkbox", {
                                          staticClass: "checkbox-container",
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectRow(adj)
                                            },
                                          },
                                          model: {
                                            value: adj.isSelect,
                                            callback: function ($$v) {
                                              _vm.$set(adj, "isSelect", $$v)
                                            },
                                            expression: "adj.isSelect",
                                          },
                                        })
                                      : _c("md-checkbox", {
                                          attrs: { disabled: "" },
                                        }),
                                  ],
                                  1
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "name-container" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            adj.createdDate,
                                            _vm.DATE_TYPES.standardDate
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                                adj.teamMemberName
                                  ? _c(
                                      "md-table-cell",
                                      { staticClass: "name-container" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(adj.teamMemberName) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "md-table-cell",
                                      { staticClass: "name-container" },
                                      [_vm._v(_vm._s(adj.customerName))]
                                    ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "name-container" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            adj.tripDate,
                                            _vm.DATE_TYPES.standardDate
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                                adj.percentageAmount
                                  ? _c(
                                      "md-table-cell",
                                      { staticClass: "name-container" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(adj.percentageAmount) +
                                            "%\n                                "
                                        ),
                                      ]
                                    )
                                  : adj.amount < 0
                                  ? _c(
                                      "md-table-cell",
                                      { staticClass: "name-container" },
                                      [
                                        _vm._v(
                                          "\n                                    (" +
                                            _vm._s(
                                              _vm._f("currency")(
                                                adj.amount,
                                                _vm.user.teamCurrency
                                              )
                                            ) +
                                            ")\n                                "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "md-table-cell",
                                      { staticClass: "name-container" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                adj.amount,
                                                _vm.user.teamCurrency
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                _c("md-table-cell", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.getCategory(
                                          adj.invoiceAdjustmentCategory
                                            .invoiceAdjustmentCategoryId
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _c("md-table-cell", [
                                  _vm._v(_vm._s(adj.description)),
                                ]),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "name-container" },
                                  [_vm._v(_vm._s(adj.createByUserName))]
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "name-container" },
                                  [_vm._v(_vm._s(adj.approvedByUserName))]
                                ),
                                _c(
                                  "md-table-cell",
                                  { staticClass: "name-container" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          "status status-" +
                                          _vm
                                            .getStatus(
                                              adj.invoiceAdjustmentStatusId
                                            )
                                            .toLowerCase()
                                            .replace(/\s+/g, ""),
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.getStatus(
                                                adj.invoiceAdjustmentStatusId
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.isTeamOwner
                                  ? _c(
                                      "md-table-cell",
                                      { staticClass: "actions-container" },
                                      [
                                        _vm.hideIfDeleted(adj)
                                          ? _c(
                                              "div",
                                              [
                                                _vm.show(adj) &&
                                                _vm.showApproveIcon(adj)
                                                  ? _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-success md-just-icon md-round action-icon",
                                                        attrs: {
                                                          title: "Approve",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.approveAdjustment(
                                                              adj
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !adj.approving
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c("md-icon", [
                                                                  _vm._v(
                                                                    "thumb_up"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sync-loader",
                                                              },
                                                              [
                                                                _c(
                                                                  "straight-line-loader"
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.show(adj) &&
                                                _vm.showUnapproveIcon(adj)
                                                  ? _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-danger md-just-icon md-round action-icon",
                                                        attrs: {
                                                          title: "Deny",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.denyAdjustment(
                                                              adj
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !adj.denying
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c("md-icon", [
                                                                  _vm._v(
                                                                    "thumb_down"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sync-loader",
                                                              },
                                                              [
                                                                _c(
                                                                  "straight-line-loader"
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.show(adj) &&
                                                _vm.showEditIcon(adj)
                                                  ? _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-warning md-just-icon md-round action-icon",
                                                        attrs: {
                                                          title: "Edit",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.edit(adj)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("md-icon", [
                                                          _vm._v("edit"),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.show(adj) &&
                                                _vm.showDeleteIcon(adj)
                                                  ? _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-danger md-just-icon md-round action-icon",
                                                        attrs: {
                                                          title: "Delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.deleteAdjustment(
                                                              adj
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !adj.deleting
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c("md-icon", [
                                                                  _vm._v(
                                                                    "delete"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sync-loader",
                                                              },
                                                              [
                                                                _c(
                                                                  "straight-line-loader"
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          })
                        : [
                            _vm.isLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-loader loading-position",
                                  },
                                  [
                                    _c("fade-loader", {
                                      attrs: {
                                        loading: _vm.isLoading,
                                        color: "#333333",
                                      },
                                    }),
                                    _c("span", [_vm._v("LOADING")]),
                                  ],
                                  1
                                )
                              : _c("p", { staticClass: "no-result-message" }, [
                                  _vm._v(
                                    "\n                                No results matching your search/filter could be found.\n                            "
                                  ),
                                ]),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c(
          "md-card-actions",
          {
            staticClass: "page-footer",
            attrs: { "md-alignment": "space-between" },
          },
          [
            _c("div", [
              _vm.total === _vm.pagination.perPage
                ? _c("p", { staticClass: "card-category" }, [
                    _vm._v(
                      "\n                    Page " +
                        _vm._s(_vm.pagination.currentPage) +
                        " of many\n                "
                    ),
                  ])
                : _c("p", { staticClass: "card-category" }, [
                    _vm._v(
                      "Page " +
                        _vm._s(_vm.pagination.currentPage) +
                        " of " +
                        _vm._s(_vm.totalPages)
                    ),
                  ]),
            ]),
            _c("pagination", {
              staticClass: "pagination-no-border pagination-success",
              attrs: { "per-page": _vm.pagination.perPage, total: _vm.total },
              on: {
                "change-page": function ($event) {
                  return _vm.handleChangePage($event, _vm.pagination.perPage)
                },
              },
              model: {
                value: _vm.pagination.currentPage,
                callback: function ($$v) {
                  _vm.$set(_vm.pagination, "currentPage", $$v)
                },
                expression: "pagination.currentPage",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }